import { render, staticRenderFns } from "./CreatorRequest.vue?vue&type=template&id=64a02740&"
import script from "./CreatorRequest.vue?vue&type=script&lang=js&"
export * from "./CreatorRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports